export const WORKSPACE_AGENT_MINIMIZE_FOCUS_RESCUE_TEST_IDS = {
  assetViewTasks: 'ASSET_MODAL_WORKSPACE_AGENT_TASKS_BUTTON',
  headerStartTask: 'WORKSPACE_CHROME_AGENT_START_TASK_BUTTON',
  selectionBarClear: 'SELECTION_ACTION_BAR_CLEAR_BTN',
  selectionBarStartTask: 'SELECTION_ACTION_BAR_START_TASK',
} as const;

export type QueryWorkspaceAgentMinimizeFocusRescueByTestId = (testId: string) => HTMLElement | null;

export type GetWorkspaceAgentMinimizeFocusRescueParams = {
  assetViewOpen: boolean;
  queryByTestId: QueryWorkspaceAgentMinimizeFocusRescueByTestId;
  ui2026: boolean;
};

export type WorkspaceAgentMinimizeFocusRescue = {
  pendingFocus: 'fab' | null;
  rescue: HTMLElement | null;
};

/**
 * Where keyboard focus should land after Minimize unmounts the panel. Prefer the layout's own
 * control when it is mounted, then any other still-mounted agent entry, then the pre-ui2026 idle
 * FAB via `pendingFocus: 'fab'` once that button mounts.
 */
export const getWorkspaceAgentMinimizeFocusRescue = ({
  assetViewOpen,
  queryByTestId,
  ui2026,
}: GetWorkspaceAgentMinimizeFocusRescueParams): WorkspaceAgentMinimizeFocusRescue => {
  const assetViewTasks = queryByTestId(WORKSPACE_AGENT_MINIMIZE_FOCUS_RESCUE_TEST_IDS.assetViewTasks);
  const headerStartTask = queryByTestId(WORKSPACE_AGENT_MINIMIZE_FOCUS_RESCUE_TEST_IDS.headerStartTask);
  const selectionBarStartTask = queryByTestId(WORKSPACE_AGENT_MINIMIZE_FOCUS_RESCUE_TEST_IDS.selectionBarStartTask);
  const selectionBarClear = queryByTestId(WORKSPACE_AGENT_MINIMIZE_FOCUS_RESCUE_TEST_IDS.selectionBarClear);

  let rescue: HTMLElement | null = null;

  if (assetViewOpen) {
    rescue = assetViewTasks;
  } else if (ui2026) {
    rescue = headerStartTask;
  }

  rescue = rescue ?? headerStartTask ?? selectionBarStartTask ?? selectionBarClear ?? assetViewTasks;

  if (rescue) {
    return {
      pendingFocus: null,
      rescue,
    };
  }

  return {
    pendingFocus: assetViewOpen || ui2026 ? null : 'fab',
    rescue: null,
  };
};
